import { LearnMoreNavButton } from "../Navbar/NavbarElements";
import DarkiLogo from "../../assets/logos/DarkivoreLogo.png";
import TaceLogo from "../../assets/logos/TacivoarLogo.png";
import OctivoreLogo from "../../assets/logos/Octivore Logo.png";
import RedAgentLogo from "../../assets/logos/red-agent-logo-red.png";
import BlueAgentLogo from "../../assets/logos/blue-agent-logo-colored.png";
import { ProductBody, ProductContainer, ProductImage, ProductNav, ProductRow, ProductTitle } from "./ProductNavItemElements";

const ProductNavItem = ({ navigate }) => {
    return <ProductNav>
        <ProductRow>
            <ProductImage src={DarkiLogo} alt="" />
            <ProductContainer>
                <ProductTitle>
                    DRP & CTI
                </ProductTitle>
                <ProductBody>
                    <div>
                        Digital Risk Protection
                    </div>
                    <div>
                        Brand Protection
                    </div>
                    <div>
                        Attack Surface & CTI
                    </div>
                    <div>
                        Cyberthreat Takedown
                    </div>
                </ProductBody>
                <LearnMoreNavButton id={'menu-darki-learn-more'} style={{ padding: '0.35vw' }} color={"#70AB46"} to="/darkivore">LEARN MORE</LearnMoreNavButton>
            </ProductContainer>
        </ProductRow>
        <ProductRow>
            <ProductImage src={TaceLogo} alt="" />
            <ProductContainer>
                <ProductTitle>
                    SIEM++
                </ProductTitle>
                <ProductBody>
                    <div>
                        Threat Detection
                    </div>
                    <div>
                        Flexible Parsing
                    </div>
                    <div>
                        SOAR Capabilities
                    </div>
                    <div>
                        User Entity & Behavior Analytics
                    </div>
                </ProductBody>
                <LearnMoreNavButton id={'menu-taci-learn-more'} color={"#8EC0E8"} to="/tacivoar">LEARN MORE</LearnMoreNavButton>
            </ProductContainer>
        </ProductRow>
        <ProductRow>
            <ProductImage src={OctivoreLogo} alt="" />
            <ProductContainer>
                <ProductTitle>
                    SECURITY IR
                </ProductTitle>
                <ProductBody>
                    <div>
                        Alerts Aggregation
                    </div>
                    <div>
                        Support for Any SIEM
                    </div>
                    <div>
                        Centralized Ticket Management
                    </div>
                    <br />
                </ProductBody>
                <LearnMoreNavButton id={'menu-octi-learn-more'} color={"#E9D24A"} to="/octivore">LEARN MORE</LearnMoreNavButton>
            </ProductContainer>
        </ProductRow>
        <ProductRow>
            <ProductImage src={RedAgentLogo} alt="" />
            <ProductContainer>
                <ProductTitle>
                    AI PENTESTING
                </ProductTitle>
                <ProductBody>
                    <div>
                        Continuous Testing
                    </div>
                    <div>
                        Grey/Black/White-Box Analysis
                    </div>
                    <div>
                        Business Logic Validation
                    </div>
                    <br />
                </ProductBody>
                <LearnMoreNavButton id={'menu-red-agent-learn-more'} color={"#ba2926"} to="/the-red-agent">LEARN MORE</LearnMoreNavButton>
            </ProductContainer>
        </ProductRow>
        <ProductRow>
            <ProductImage src={BlueAgentLogo} alt="" />
            <ProductContainer>
                <ProductTitle>
                    AI SOC ANALYST
                </ProductTitle>
                <ProductBody>
                    <div>
                        Continuous Threat Hunting
                    </div>
                    <div>
                        Cross-Layer Threat Correlation
                    </div>
                    <div>
                        Autonomous Incident Investigation
                    </div>
                    <br />
                </ProductBody>
                <LearnMoreNavButton id={'menu-blue-agent-learn-more'} color={"#255daa"} to="/the-blue-agent">LEARN MORE</LearnMoreNavButton>
            </ProductContainer>
        </ProductRow>
    </ProductNav>
}

export default ProductNavItem;